/*
 * Shortens same-month date ranges in Sternify's shipping timeline app block:
 * "October 13 - October 15" becomes "October 13-15". Ranges across two months
 * ("October 30 - November 2") are left as they are.
 *
 * The app renders and re-renders its text client side, so this watches its
 * container and rewrites matching text nodes after each render.
 */
(() => {
  const SAME_MONTH = /^(\s*)([A-Za-z]+)\s+(\d{1,2})\s*[-–]\s*\2\s+(\d{1,2})(\s*)$/;

  const shorten = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      const match = node.nodeValue.match(SAME_MONTH);
      if (match) node.nodeValue = `${match[1]}${match[2]} ${match[3]}-${match[4]}${match[5]}`;
    }
  };

  const watch = (container) => {
    shorten(container);
    // Rewriting text fires the observer again; the rewritten text no longer matches, so it settles.
    new MutationObserver(() => shorten(container)).observe(container, { childList: true, characterData: true, subtree: true });
  };

  const init = () => {
    const timelines = document.querySelectorAll('[id^="st-shipping-timeline"]');
    if (timelines.length) {
      timelines.forEach(watch);
      return;
    }
    // The app block may mount after this script runs: wait for it once.
    const pending = new MutationObserver(() => {
      const found = document.querySelectorAll('[id^="st-shipping-timeline"]');
      if (!found.length) return;
      pending.disconnect();
      found.forEach(watch);
    });
    pending.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => pending.disconnect(), 20000); // no timeline on this page
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
